var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"video"}},[_c('iframe',{attrs:{"src":"https://www.youtube.com/embed/FlcYo5RP_-c","height":_vm.frameHeight,"width":_vm.frameWidth,"frameborder":"0","allow":"autoplay; fullscreen","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }